import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'
import { routerReducer as router } from 'react-router-redux'

import app from './app'
import authen from './authen'
import roleMan from './roleMan'
import product from './product'
import pr from './purchaseRequisition'
import rfq from './rfq'
import po from './purchaseOrder'
import gr from './goodsServiceReceipt'
import contract from './contract'
import options from './options'
import member from './member'
import goa from './goa'
import workList from './workList'
import mappingData from './mappingData'
import downPayment from './downPayment'
import billform from './billform'
import qr from './qr'
import poUpdate from './poUpdate'
import tracking from './tracking'
import vendorMaintenance from './vendorMaintenance'
import supplier from './supplier'
import address from './address'
import report from './report'
import system from './system'
import dataManagement from './dataManagement'
import shortList from './shortList'
import support from './support'
import codeOfConduct from './codeOfConduct'
import bg from './bankGuarantee'
import bgRequest from './bankGuaranteeRequest'
import bgCompanyRequest from './bgCompanyRequest'
import bgCompany from './bgCompany'
import bgLimitOfBank from './bgLimitOfBank'

export default combineReducers({
  app,
  authen,
  roleMan,
  pr,
  rfq,
  po,
  gr,
  report,
  contract,
  options,
  member,
  form: formReducer,
  router,
  product,
  goa,
  workList,
  mappingData,
  downPayment,
  billform,
  qr,
  poUpdate,
  tracking,
  vendorMaintenance,
  supplier,
  address,
  system,
  dataManagement,
  support,
  shortList,
  codeOfConduct,
  bg,
  bgRequest,
  bgCompanyRequest,
  bgCompany,
  bgLimitOfBank
})